import React from "react";
import { useSelector } from "react-redux";
import { renderProgramCard } from "../utils/render-program-card";
import { Title, Section } from "@vshp/ui-components";

const Programs = ({ border }) => {
  const { programs, programsDegrees } = useSelector((state) => state.programs);

  return (
    programs.length > 0 &&
    programsDegrees.length > 0 && (
      <Section border={border}>
        <Title type="h2">Программы обучения</Title>
        <div className="programs-feed__wrapper">{renderProgramCard(programs)}</div>
      </Section>
    )
  );
};

export default Programs;
